import React from "react";

// boundingBox is normalized two-corner coords {x1,y1,x2,y2}, each 0-1, relative to the
// full original image, origin top-left (e.g. {x1:0.67, y1:0.28, x2:0.70, y2:0.49}).
// containerSize/naturalSize let us compute the actual displayed image rect so the box
// lines up correctly even when objectFit:contain letterboxes the image inside its container.
const getContainRect = (containerWidth, containerHeight, naturalWidth, naturalHeight) => {
  if (!containerWidth || !containerHeight || !naturalWidth || !naturalHeight) return null;
  const scale = Math.min(containerWidth / naturalWidth, containerHeight / naturalHeight);
  const width = naturalWidth * scale;
  const height = naturalHeight * scale;
  return {
    left: (containerWidth - width) / 2,
    top: (containerHeight - height) / 2,
    width,
    height,
  };
};

const BoundingBoxOverlay = ({ boundingBox, containerSize, naturalSize, color = "#00FF00" }) => {
  const imageRect = getContainRect(containerSize?.width, containerSize?.height, naturalSize?.width, naturalSize?.height);

  if (!boundingBox || !imageRect) return null;

  const { x1, y1, x2, y2 } = boundingBox;
  const boxLeft = imageRect.left + x1 * imageRect.width;
  const boxTop = imageRect.top + y1 * imageRect.height;
  const boxWidth = (x2 - x1) * imageRect.width;
  const boxHeight = (y2 - y1) * imageRect.height;

  return (
    <div
      data-testid="bounding-box-overlay"
      style={{
        position: "absolute",
        left: boxLeft,
        top: boxTop,
        width: boxWidth,
        height: boxHeight,
        border: `2px solid ${color}`,
        boxSizing: "border-box",
        pointerEvents: "none",
      }}
    />
  );
};

export default BoundingBoxOverlay;
